// Resources
import { IStyles } from '../../../resource';

const styles: IStyles = {
  dialog: (theme) => ({
    width: { xs: 'calc(100vw - 40px)', sm: 560 },
    maxWidth: 560,
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(30, 0, 30, 0),
    p: {
      xs: theme.spacing(32, 24, 24),
      sm: theme.spacing(40, 48, 32),
    },
    position: 'relative',
  }),
  list: (theme) => ({
    pl: theme.spacing(20),
    m: 0,
    '& li': {
      mb: theme.spacing(12),
      color: theme.palette.gray?.dark || theme.palette.text.secondary,
      fontSize: theme.typography.body2?.fontSize,
      lineHeight: 1.6,
    },
    '& li:last-of-type': {
      mb: 0,
    },
  }),
};

export default styles;
